import ProductImage from '@assets/png/product.png';
import CloseImage from '@assets/svg/close-ticket.svg';
import { State } from '@hookstate/core';
import { IProduct } from '@models/Product.model';
import {
  Buttons,
  CloseButton,
  ColumnDiv,
  Container,
  Field,
  Header,
  Image,
  Label,
  LinkText,
  MatchButton,
  RowDiv,
  WindowButton,
  WindowButtonImage,
} from './ProductDetail.styles';

interface IAddFieldContent {
  openAddField: State<boolean>;
  detailProduct: IProduct | undefined;
  onClickMatch: () => void;
}

const ProductDetail = ({
  openAddField,
  onClickMatch,
  detailProduct,
}: IAddFieldContent) => {
  if (!detailProduct) return <div />;
  return (
    <Container>
      <Header style={{ marginBottom: 16 }}>
        Product Details
        <CloseButton
          onClick={() => {
            openAddField.set(false);
          }}
        >
          <WindowButtonImage src={CloseImage} />
        </CloseButton>
      </Header>
      <RowDiv>
        {detailProduct.imageUrl ? (
          <Image src={detailProduct.imageUrl} alt="" />
        ) : (
          <Image src={ProductImage} alt="" />
        )}
        <ColumnDiv>
          <div style={{ marginBottom: 16, marginRight: 16 }}>
            <Label>Product Name</Label>
            <Field>{detailProduct.name}</Field>
          </div>
          <div style={{ marginRight: 16 }}>
            <Label>Model #</Label>
            <Field>{detailProduct.model}</Field>
          </div>
        </ColumnDiv>
        <ColumnDiv>
          <div style={{ marginBottom: 16, marginRight: 16 }}>
            <Label>Product Page</Label>
            <LinkText
              onClick={() => {
                if (
                  detailProduct.productPage &&
                  !detailProduct.productPage.includes('www.bhphotovideo.coms')
                )
                  window.open(detailProduct.productPage, '_blank');
              }}
            >
              {detailProduct.productPage &&
              !detailProduct.productPage.includes('www.bhphotovideo.com')
                ? `${
                    detailProduct.model.length > 0
                      ? detailProduct.model
                      : 'Product'
                  } Page`
                : ''}
            </LinkText>
          </div>
          <div style={{ marginRight: 16 }}>
            <Label>Standard Warranty Length</Label>
            <Field>
              {detailProduct.standardWarrantyLength &&
                `${detailProduct.standardWarrantyLength} days`}
            </Field>
          </div>
        </ColumnDiv>
      </RowDiv>
      <Label>Product Description</Label>
      {/* Todo: Use mantine scrollarea */}
      <Field className="bscroll" style={{ height: '100%', overflowY: 'auto' }}>
        {detailProduct.description}
      </Field>
      <Buttons>
        <WindowButton
          onClick={() => {
            openAddField.set(false);
          }}
          style={{ marginRight: 16 }}
        >
          Close Details
        </WindowButton>
        <MatchButton onClick={onClickMatch}>Match</MatchButton>
      </Buttons>
    </Container>
  );
};

export { ProductDetail };
